import React, { useEffect, useState } from "react";

import DatePicker from "../../../../components/misc/DatePicker";
import {
  dateForDatabase,
  getDateWithoutNthMonths,
} from "../../../../utils/dateAndTime";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import Text from "../../../../styleguide/Text";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch } from "../../../../redux/hooks";
import { getDownloadIntrariProduse } from "../../../../redux/api/reports.api";

function TotalReceivedProductsHeader() {
  const dispatch = useAppDispatch();
  const { tableData, tablePagination, tableSearch, handleTableSearch } =
    useTableCtx() || {};

  const [startDate, setStartDate] = useState<Date | null>(
    getDateWithoutNthMonths(1),
  );
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("startDate", dateForDatabase(startDate));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("endDate", dateForDatabase(endDate));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  const exportRaport = async () => {
    await dispatch(
      getDownloadIntrariProduse({
        page: tablePagination?.page,
        per_page: tablePagination?.rowsPerPage,
        startDate: tableSearch.startDate,
        endDate: tableSearch.endDate,
        numeProdus: tableSearch?.numeProdus,
        numeFurnizor: tableSearch?.numeFurnizor,
        lot: tableSearch?.lot,
        codFactura: tableSearch?.codFactura,
      }),
    );
  };

  return (
    <div>
      <div className="flex justify-between mb-6">
        <Text
          variant="h3"
          component="h3"
          className="font-semibold text-slate-900 mb-4"
          gutterBottom>
          Total produse receptionate
        </Text>
        {tableData && tableData?.length > 0 && (
          <CustomButton
            variant="contained"
            withConfirmationModal={{
              modalTitle: "Exporta raport",
              modalSubtitle: "Esti sigur ca vrei sa exporti raportul?",
              modalLeftButtonText: "Anuleaza",
              modalLeftButtonVariant: "outlined",
              modalRightButtonText: "Exporta",
              modalRightButtonOnClick: exportRaport,
            }}>
            Exporta raport
          </CustomButton>
        )}
      </div>
      <div className="flex justify-between font-bold text-muted bg-surface-subtle w-full p-5">
        <DatePicker
          label="De la"
          textInputClassName="!bg-white [&_.MuiOutlinedInput-root]:!bg-white"
          isRequired
          withVerticalSpacer
          fullWith={false}
          gutterBottom={false}
          maxDate={new Date()}
          value={startDate}
          handleChangeDate={(value) => setStartDate(value)}
        />
        <DatePicker
          label="Pana la"
          textInputClassName="!bg-white [&_.MuiOutlinedInput-root]:!bg-white"
          isRequired
          withVerticalSpacer
          fullWith={false}
          gutterBottom={false}
          maxDate={new Date()}
          value={endDate}
          handleChangeDate={(value) => setEndDate(value)}
        />
      </div>{" "}
    </div>
  );
}

export default TotalReceivedProductsHeader;
